export const initialState = {
	isMaintenanceMode: false,
	loading: false,
	error: null
};

export default (state = initialState, action) => {
	switch (action.type) {
		case 'GET_MAINTENANCE_MODE_REQUEST':
			return { ...state, loading: true, error: null };
		case 'GET_MAINTENANCE_MODE_SUCCESS':
			return { 
				...state, 
				isMaintenanceMode: action.payload,
				loading: false,
				error: null
			};
		case 'GET_MAINTENANCE_MODE_FAILURE':
			return { 
				...state, 
				loading: false,
				error: action.payload
			};
		case 'UPDATE_MAINTENANCE_MODE_REQUEST_REQUEST':
			return { ...state, loading: true, error: null };
		case 'UPDATE_MAINTENANCE_MODE_REQUEST_SUCCESS':
			return { 
				...state, 
				isMaintenanceMode: action.payload,
				loading: false,
				error: null
			};
		case 'UPDATE_MAINTENANCE_MODE_REQUEST_FAILURE':
			return { 
				...state, 
				loading: false,
				error: action.payload
			};
		default:
			return state;
	}
};
